import { render, staticRenderFns } from "./today-cashback.vue?vue&type=template&id=5860be0c&"
import script from "./today-cashback.vue?vue&type=script&lang=js&"
export * from "./today-cashback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports